import { useEffect } from "react";

/**
 * WhatsAppFloatingButton — global floating WhatsApp CTA shown on every page.
 * Opens wa.me/917619300505 in a new tab. Lightweight, no 3rd-party SDK.
 */
const WA_NUMBER = "917619300505";

export default function WhatsAppFloatingButton() {
  useEffect(() => {
    // No side effects needed; kept for future enhancements (e.g. show after scroll).
  }, []);

  return (
    <a
      href={`https://wa.me/${WA_NUMBER}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Pivotbox on WhatsApp"
      className="pb-wa-float"
      data-testid="whatsapp-floating-btn"
    >
      <svg viewBox="0 0 32 32" width="28" height="28" fill="#FFFFFF" aria-hidden="true">
        <path d="M16.001 3C9.374 3 4 8.373 4 14.999c0 2.378.71 4.586 1.93 6.43L4 29l7.78-1.872a12.05 12.05 0 0 0 4.221.77h.001C22.626 27.898 28 22.525 28 15.9 28 12.78 26.78 9.83 24.566 7.616 22.353 5.401 19.403 3 16.001 3zm0 21.83h-.002c-1.302 0-2.582-.349-3.7-1.008l-.265-.157-4.617 1.112 1.156-4.5-.173-.276a9.9 9.9 0 0 1-1.508-5.213c0-5.483 4.464-9.946 9.949-9.946 2.656 0 5.152 1.034 7.029 2.911s2.91 4.375 2.91 7.029c-.001 5.483-4.466 9.948-9.95 9.948zm5.456-7.448c-.299-.149-1.769-.873-2.043-.972-.274-.099-.473-.149-.672.15-.199.298-.771.971-.946 1.17-.174.199-.349.224-.647.075-.299-.15-1.261-.464-2.402-1.482-.888-.793-1.487-1.772-1.663-2.071-.174-.298-.018-.46.131-.609.134-.134.299-.349.448-.523.149-.174.199-.298.298-.497.099-.199.05-.373-.025-.523-.075-.15-.672-1.62-.921-2.218-.243-.582-.49-.504-.672-.513l-.572-.01a1.1 1.1 0 0 0-.797.373c-.273.298-1.045 1.021-1.045 2.49 0 1.469 1.07 2.889 1.219 3.088.149.199 2.105 3.216 5.099 4.51.713.308 1.269.491 1.702.628.715.227 1.366.195 1.881.118.574-.086 1.769-.722 2.018-1.42.249-.697.249-1.295.174-1.42-.075-.124-.273-.199-.572-.348z"/>
      </svg>
    </a>
  );
}
